export default "__VITE_ASSET__BRtNZLPD__"